import { IMasterAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function getMasterAgentId(masterAgent?: IMasterAgentSchema): number | undefined {
  return (masterAgent && masterAgent.cianUserId) || undefined;
}
